// Centralized Services Data Model for Standalone Service Landing Pages (/services/:slug)
import ivTherapy from '../assets/images/halo services/iv.jpg';
import mesotherapy from '../assets/images/halo services/mesotherapy.jpg';
import prp from '../assets/images/halo services/prp.jpg';
import filler from '../assets/images/halo services/dermalfiller.jpeg';
import neurotoxin from '../assets/images/halo services/botox.jpg';
import belkyra from '../assets/images/halo services/belkyra.png';
import sculptra from '../assets/images/halo services/sculptra.jpg';
import radiesse from '../assets/images/halo services/radiesse.jpg';
import harmonyca from '../assets/images/halo services/harmonyca.png';
import instalift from '../assets/images/halo services/instalift.jpg';
import hydrafacial from '../assets/images/halo services/hydrafacial.jpg';
import bblHero from '../assets/images/halo services/BBLHERO.png';
import ultherapy from '../assets/images/halo services/ultherapy.png';
import potenza from '../assets/images/halo services/Potenza.jpg';
import visia from '../assets/images/halo services/visia.png';
import bodyfiller from '../assets/images/halo services/bodyfiller.jpg';
import belkyrabody from '../assets/images/halo services/belkyrabody.jpg';
import ultherapybody from '../assets/images/halo services/ultherapybody.jpg';
import skincare from '../assets/images/halo services/soft2.jpg';
import skinTagRemoval from '../assets/images/halo services/hyfracator.png';
import picosurePro from '../assets/images/halo services/picosurepro.png';
import microneedlingImage from '../assets/images/halo services/microneedling.jpeg';
import thermage from '../assets/images/halo services/thermage.png';

export const servicesData = [
  {
    slug: 'iv-therapy',
    id: 1,
    category: 'injection',
    image: ivTherapy,
    en: {
      title: 'IV Therapy',
      subtitle: 'Nutrient-rich IV infusions for hydration, energy, immunity, and skin radiance.',
      description: 'Derma-Bright | Myers | Meta-Burn | Sweet Dreams | NAD+',
      purpose: 'To replenish hydration, boost energy, and deliver essential vitamins, minerals, and antioxidants directly into the bloodstream.',
      mechanism: 'Nutrients are administered intravenously, bypassing the digestive system for 100% cellular absorption and immediate revitalizing effects.',
      duration: 'Treatment takes approx 30–60 minutes. Effects are felt immediately and last several days to 2 weeks.',
      features: [
        'Immediate cellular hydration & nutrition',
        'Energy boost & chronic fatigue relief',
        'Immune system support & detox',
        'Skin brightening & anti-aging benefits'
      ],
      indications: [
        'Dull skin or uneven complexion',
        'Low energy, burnout, or chronic fatigue',
        'Dehydration & jet lag',
        'Weak immune system'
      ],
      process: [
        { title: 'Consultation', desc: 'Customized formulation selection based on your wellness goals.' },
        { title: 'Preparation', desc: 'Vital checks and comfortable seating in our relaxing lounge.' },
        { title: 'Infusion', desc: 'Intravenous drip administered by licensed medical practitioners (30-45 mins).' },
        { title: 'Post-Care', desc: 'Immediate resumption of daily activities with sustained energy.' }
      ],
      faq: [
        { q: 'How often should I get IV Therapy?', a: 'For optimum wellness, many clients receive infusions every 2–4 weeks or prior to major events.' },
        { q: 'Is IV Therapy safe?', a: 'Yes, all formulations are medical-grade and administered by experienced professionals.' }
      ],
      subServices: [
        { name: 'IV Derma-Bright', ingredients: 'Glutathione + Vitamin C', benefits: ['Cellular antioxidant protection', 'Complexion brightening', 'Slows aging signs'] },
        { name: 'IV Myers', ingredients: 'Vitamin B-complex + Vitamin C + Minerals + Amino acids', benefits: ['Fights fatigue', 'Supports immune system', 'Speeds recovery'] },
        { name: 'IV Meta-Burn', ingredients: 'Vitamins + B12-complex + Minerals + Lipotropics', benefits: ['Accelerates metabolism', 'Liver fat processing', 'Boosts energy'] },
        { name: 'IV Sweet Dreams', ingredients: 'Vitamins + Trace Minerals + Amino acids', benefits: ['Better sleep quality', 'Nervous system relaxation', 'Stress reduction'] },
        { name: 'IV NAD+', ingredients: 'NAD+ Coenzyme', benefits: ['Cellular DNA repair', 'Cognitive clarity & focus', 'Anti-aging at cellular level'] }
      ],
      meta: {
        title: 'IV Therapy Richmond Hill | Derma-Bright, Myers, NAD+ | Halo Clinic',
        description: 'Boost energy, immunity, and skin radiance with medical-grade IV Drips in Richmond Hill. Custom formulations including NAD+, Derma-Bright, and Myers.'
      }
    },
    cn: {
      title: '静脉营养针（IV Therapy）',
      subtitle: '快速补充水分、提升免疫力、改善肤色与抗衰老的高效静脉营养护理。',
      description: '美白针 | 迈尔斯能量针 | 燃脂针 | 助眠针 | NAD+ 长寿因子针',
      purpose: '通过静脉将高浓度维生素、矿物质和抗氧化成分直接输送到血液中，快速恢复机体活力。',
      mechanism: '静脉给药绕过消化道损耗，达到100%吸收利用率，迅速改善身体与皮肤状态。',
      duration: '单次治疗约30-60分钟，效果即刻显现并持续数天至两周。',
      features: [
        '即刻深层补水与营养供给',
        '显著提升体能与缓解疲劳',
        '增强免疫系统与肝脏排毒',
        '全身肌肤美白与抗衰老'
      ],
      indications: [
        '肤色暗沉、色斑、无光泽',
        '长期熬夜、慢性疲劳、精力不足',
        '免疫力低下、易感冒',
        '代谢缓慢或睡眠质量差'
      ],
      process: [
        { title: '专业问诊', desc: '根据您的身体需求定制专属营养配方。' },
        { title: '护理准备', desc: '测量生命体征并在舒适静音休憩区准备。' },
        { title: '静脉滴注', desc: '持牌医护人员规范操作进行滴注（约30-45分钟）。' },
        { title: '完成离开', desc: '无恢复期，可立即恢复正常工作与生活。' }
      ],
      faq: [
        { q: '静脉营养针多久做一次比较好？', a: '根据个人需求，建议每2-4周进行一次定期保养，或在重要活动前快速提升状态。' },
        { q: '治疗过程安全吗？', a: '绝对安全，所有配方均采用医疗级成分，由经验丰富的注册医护人员全程操作。' }
      ],
      subServices: [
        { name: 'IV 美白焕肤针', ingredients: '谷胱甘肽 + 高浓度维生素C', benefits: ['消除自由基抗氧化', '抑制黑色素生成', '提亮全身肤色'] },
        { name: 'IV 迈尔斯能量针', ingredients: '复合维B + 维C + 矿物质 + 氨基酸', benefits: ['快速补充体力', '增强身体免疫力', '缓解肌肉酸痛与疲劳'] },
        { name: 'IV 代谢燃脂针', ingredients: '维B12 + 亲脂因子 + 氨基酸', benefits: ['促进肝脏脂肪代谢', '加速新陈代谢速率', '提升精力'] },
        { name: 'IV 助眠镇静针', ingredients: '微量元素 + 镇静氨基酸', benefits: ['提升血清素合成', '改善失眠与睡眠质量', '放松神经系统'] },
        { name: 'IV NAD+ 细胞长寿针', ingredients: '高纯度 NAD+', benefits: ['修复DNA损伤与抗衰老', '提升大脑认知与注意力', '增强细胞线粒体能量'] }
      ],
      meta: {
        title: 'Richmond Hill 美白针与静脉营养针 | NAD+, Myers | Halo Clinic医美',
        description: 'Richmond Hill专业静脉营养针护理，提供美白针、迈尔斯能量针、NAD+细胞修复针，快速恢复身体精力与亮白肌肤。'
      }
    }
  },
  {
    slug: 'mesotherapy',
    id: 2,
    category: 'injection',
    image: mesotherapy,
    en: {
      title: 'Mesotherapy',
      subtitle: 'Targeted micro-injections of nutrient cocktails for luminous, deeply hydrated skin.',
      description: 'Tiny injections of vitamins and nutrients placed under the skin to rejuvenate, brighten, hydrate, and improve texture.',
      purpose: 'Delivers customized vitamins, hyaluronic acid, and peptides into the mesoderm layer to revitalize dull skin.',
      mechanism: 'Micro-injections stimulate natural collagen while feeding the dermis essential nutrients for cellular repair.',
      duration: 'Session takes 45-60 mins. Results develop over 1-2 weeks and last 3-6 months after a series.',
      features: [
        'Deep dermal hydration & glow',
        'Improves skin elasticity & texture',
        'Reduces fine lines & pore visibility',
        'Minimally invasive with rapid recovery'
      ],
      indications: ['Dehydrated, dull skin', 'Fine lines & initial aging', 'Uneven texture', 'Dark circles'],
      process: [
        { title: 'Cleansing & Numbing', desc: 'Topical numbing cream applied for maximal comfort.' },
        { title: 'Micro-injections', desc: 'Precise delivery of nutrient solution into targeted zones.' },
        { title: 'Soothing Mask', desc: 'Calming sheet mask to diminish post-treatment redness.' }
      ],
      faq: [{ q: 'Is Mesotherapy painful?', a: 'Topical anesthesia is applied beforehand, making the discomfort minimal.' }],
      meta: { title: 'Mesotherapy Injections Richmond Hill | Skin Brightening | Halo Clinic', description: 'Rejuvenate your skin with Mesotherapy in Richmond Hill. Deep hydration, radiant complexion, and nutrient delivery.' }
    },
    cn: {
      title: '水光针与中胚层疗法（Mesotherapy）',
      subtitle: '将高浓度玻尿酸与营养成分精准注入皮肤中胚层，焕发水润光彩。',
      description: '精准微量注射营养精华，深层补水、提亮肤色、改善肤质与细纹。',
      purpose: '直接向真皮层补充透明质酸、维生素及肽类，彻底解决干燥与暗沉。',
      mechanism: '通过中胚层微针注入，激活细胞再生与胶原合成。',
      duration: '治疗需约45-60分钟，效果持续3-6个月。',
      features: ['深层补水锁水', '提亮透白肤色', '收缩毛孔与平滑细纹', '恢复皮肤弹性'],
      indications: ['皮肤干燥缺水', '肤色暗黄无光泽', '细纹与毛孔粗大'],
      process: [
        { title: '清洁敷麻', desc: '表面敷麻20-30分钟，确保过程无痛。' },
        { title: '精准注射', desc: '医护人员精准将水光精华注入中胚层。' },
        { title: '镇静医用面膜', desc: '使用镇静冷敷贴舒缓褪红。' }
      ],
      faq: [{ q: '需要几次见效？', a: '单次即可看到皮肤明显提亮补水，建议连续3次作为一个周期效果更佳。' }],
      meta: { title: 'Richmond Hill 水光针中胚层疗法 | 深层补水美白 | Halo Clinic医美', description: 'Richmond Hill专业水光针与中胚层注入，深层补水、提亮肤色、细腻肤质。' }
    }
  },
  {
    slug: 'prp-vampire-facial',
    id: 3,
    category: 'injection',
    image: prp,
    en: {
      title: 'PRP (Platelet-Rich Plasma)',
      subtitle: 'Autologous growth factor therapy for skin renewal, scar repair, and hair restoration.',
      description: 'Using your own blood\'s healing factors, PRP stimulates collagen, improves skin quality, reduces scars, and can help with hair growth.',
      purpose: 'Natural cell regeneration using concentrated platelets rich in essential growth factors.',
      mechanism: 'Blood sample is spun in a centrifuge to isolate rich plasma, then injected into target area.',
      duration: '45-60 mins per session. Results appear in weeks and last 12-18 months.',
      features: ['100% natural from your own body', 'Stimulates deep collagen & elastin', 'Improves acne scars & under-eye dark circles', 'Promotes hair follicle regeneration'],
      indications: ['Under-eye hollowing & dark circles', 'Acne scarring & uneven skin', 'Hair thinning / loss', 'Aging skin laxity'],
      process: [
        { title: 'Blood Draw', desc: 'Small sample drawn from arm, identical to standard blood test.' },
        { title: 'Centrifugation', desc: 'Plasma is separated to concentrate rich growth factors.' },
        { title: 'Injection / Microneedling', desc: 'Reinfused into face, neck, or scalp for rejuvenation.' }
      ],
      faq: [{ q: 'Are there risks of allergic reactions?', a: 'No, because PRP is derived 100% from your own body.' }],
      meta: { title: 'PRP Facial & Hair Restoration Richmond Hill | Halo Clinic', description: 'Platelet-Rich Plasma (PRP) treatments in Richmond Hill for skin renewal, acne scars, and hair regrowth.' }
    },
    cn: {
      title: 'PRP 自体血清僵尸美容（PRP Platelet-Rich Plasma）',
      subtitle: '利用自身血液中的高浓度生长因子，激活细胞再生与胶原重构。',
      description: '提取自体高浓度血小板血清，有效改善细纹、痘坑痘印、黑眼圈及生发。',
      purpose: '通过天然生长因子修复受损组织，全面提升肌肤自愈力与年轻度。',
      mechanism: '离心提纯血浆中的血小板，注射或微针导入皮肤/头皮中。',
      duration: '过程约45-60分钟，效果可持续12-18个月。',
      features: ['100%自体安全无排异', '强效刺激胶原蛋白再生', '显著改善黑眼圈与痘坑', '有效防脱生发'],
      indications: ['眼周黑眼圈与细纹', '痘疤痘坑', '脱发/头发稀疏', '面部皮肤松弛暗沉'],
      process: [
        { title: '抽血采样', desc: '抽取少量静脉血（类似常规体检）。' },
        { title: '离心提纯', desc: '高速离心分离出富含生长因子的黄金血浆。' },
        { title: '精准注入', desc: '通过水光/微针导入目标修复区域。' }
      ],
      faq: [{ q: 'PRP会发生过敏吗？', a: '不会，由于采用自身血液提取成分，绝无排异或过敏风险。' }],
      meta: { title: 'Richmond Hill PRP自体血清生发与面部抗衰 | Halo Clinic医美', description: ' Richmond Hill PRP自体血浆治疗，安全修复痘坑黑眼圈，促进生发与皮肤年轻化。' }
    }
  },
  {
    slug: 'dermal-fillers',
    id: 4,
    category: 'injection',
    image: filler,
    en: {
      title: 'Dermal Fillers',
      subtitle: 'Juvederm | Stylage | Premium Hyaluronic Acid Volumizers',
      description: 'Instantly restores volume, smooths deep wrinkles, and enhances facial contours using premium hyaluronic acid.',
      purpose: 'Sculpts lips, cheeks, jawline, temples, and tear troughs while maintaining natural facial dynamics.',
      mechanism: 'Cross-linked hyaluronic acid gel is strategically placed into structural skin planes to lift and plump.',
      duration: 'Immediate results lasting 6–18 months depending on product viscosity and injection site.',
      features: ['Instant visible results', 'Reversible & safe (Hyaluronidase compatible)', 'Hydrates & volumizes simultaneously', 'Custom tailored contouring'],
      indications: ['Thin lips or blurred lip border', 'Sunken cheeks or hollow temples', 'Deep nasolabial folds & marionette lines', 'Weak chin or soft jawline'],
      process: [
        { title: 'Facial Mapping', desc: 'Assessment of structural anatomy and aesthetic harmony.' },
        { title: 'Comfort Numbing', desc: 'Topical anesthetic or integrated lidocaine for pain-free treatment.' },
        { title: 'Injection', desc: 'Precision cannula or needle technique (20-30 mins).' },
        { title: 'Immediate Review', desc: 'Instant reveal of contoured results.' }
      ],
      faq: [{ q: 'What happens if I dislike the result?', a: 'HA fillers can be completely dissolved using an enzyme called Hyaluronidase.' }],
      meta: { title: 'Dermal Fillers Richmond Hill | Juvederm, Stylage | Halo Clinic', description: 'Restore volume and contour lips, cheeks, and jawline with dermal fillers in Richmond Hill.' }
    },
    cn: {
      title: '玻尿酸面部填充（Dermal Fillers）',
      subtitle: 'Juvederm乔雅登 | Stylage丝丽 | 精准塑形与丰盈面部凹陷',
      description: '即刻恢复面部容量，抚平深层皱纹，雕塑精致立体的面部轮廓。',
      purpose: '针对唇部、苹果肌、下巴、太阳穴及泪沟进行自然精细填补。',
      mechanism: '交联透明质酸软凝胶注入真皮深层或骨膜层，提供支撑与塑形。',
      duration: '即刻见效，效果维持6至18个月。',
      features: ['效果即刻显现', '安全可逆（可被玻尿酸溶解酶溶解）', '同时补水与充盈', '打造自然立体轮廓'],
      indications: ['唇部扁平干燥', '苹果肌凹陷、太阳穴凹陷', '法令纹、木偶纹深', '下巴短小或下颌线模糊'],
      process: [
        { title: '美学评估', desc: '根据个人面部结构制定个性化塑形方案。' },
        { title: '敷麻舒缓', desc: '使用表麻膏及含麻醉剂的优质玻尿酸。' },
        { title: '精细注射', desc: '采用钝针/锐针技术进行层次注射。' },
        { title: '塑形确认', desc: '现场确认自然丰满立体的塑形效果。' }
      ],
      faq: [{ q: '如果对效果不满意可以恢复吗？', a: '可以，玻尿酸可以通过注射玻尿酸溶解酶完全安全溶解恢复。' }],
      meta: { title: 'Richmond Hill 玻尿酸丰唇丰苹果肌下巴 | Halo Clinic医美', description: 'Richmond Hill专业玻尿酸填充注射，选用乔雅登、丝丽等顶级品牌，打造自然立体面部轮廓。' }
    }
  },
  {
    slug: 'botox-neurotoxin',
    id: 5,
    category: 'injection',
    image: neurotoxin,
    en: {
      title: 'Botox & Neurotoxin Injections',
      subtitle: 'Botox | Dysport | Xeomin for wrinkle smoothing and facial slimming.',
      description: 'Softens expression lines like forehead lines, crow\'s feet, and frown lines. Contours jawline (masseter slimming) for a refined V-shape.',
      purpose: 'Relaxes overactive facial muscles to diminish dynamic wrinkles and refine facial structure.',
      mechanism: 'Temporarily blocks nerve impulses to targeted muscles, preventing repetitive micro-contractions.',
      duration: 'Results visible in 3-7 days, full effect at 14 days, lasting 3–4 months.',
      features: ['Smoothens forehead lines & crow\'s feet', 'Masseter reduction for V-line jawline', 'Prevents permanent deep wrinkles', 'Zero downtime lunchtime procedure'],
      indications: ['Forehead wrinkles & frown lines', 'Crow\'s feet around eyes', 'Enlarged masseter muscles (jaw clenching)', 'Trapezius muscle relaxation (slim neck)'],
      process: [
        { title: 'Dynamic Analysis', desc: 'Evaluation of active expression lines.' },
        { title: 'Micro-Injections', desc: 'Quick, ultra-fine pinpricks into precise muscle sites (10 mins).' },
        { title: 'Aftercare Instructions', desc: 'Avoid lying down for 4 hours; no strenuous workouts for 24h.' }
      ],
      faq: [{ q: 'Will my face look frozen?', a: 'Our expert injectors focus on subtle, natural movement so you look refreshed, not frozen.' }],
      meta: { title: 'Botox & Jawline Slimming Richmond Hill | Dysport, Xeomin | Halo Clinic', description: 'Smooth wrinkles and slim your jawline with Botox, Dysport, and Xeomin in Richmond Hill.' }
    },
    cn: {
      title: '肉毒素除皱与瘦脸（Botox & Neurotoxin）',
      subtitle: 'Botox保妥适 | Dysport吉适 | Xeomin西马，抚平皱纹与打造V脸。',
      description: '有效抚平抬头纹、川字纹、鱼尾纹，放松咬肌达到瘦脸效果，塑造精致下颌线。',
      purpose: '阻断神经肌肉传导，放松过度收缩的表情肌，阻断动态皱纹变成静态纹。',
      mechanism: '精准注射于目标肌肉层，暂时性放松肌肉活力。',
      duration: '3-7天起效，14天达到最佳效果，维持约3-4个月。',
      features: ['高效抚平动态皱纹', '瘦咬肌打造V脸下颌线', '瘦肩针与瘦腿针放松肌肉', '随做随走零恢复期'],
      indications: ['抬头纹、川字纹、鱼尾纹', '咬肌肥大、脸型偏方', '斜方肌发达、肩颈线条粗壮'],
      process: [
        { title: '动态面诊', desc: '评估肌肉收缩强度与注射位点。' },
        { title: '微针注射', desc: '使用极细针头快速精准注射（约10分钟）。' },
        { title: '注意事项提醒', desc: '术后4小时内避免平躺，24小时避免剧烈运动。' }
      ],
      faq: [{ q: '注射后脸部会僵硬吗？', a: '我们专业医护团队精准把控剂量与层次，保留自然表情，绝不僵硬。' }],
      meta: { title: 'Richmond Hill Botox肉毒素除皱瘦脸 | 保妥适瘦咬肌 | Halo Clinic医美', description: 'Richmond Hill专业Botox肉毒素注射，高效除皱、瘦咬肌、瘦肩针，恢复年轻紧致轮廓。' }
    }
  },
  {
    slug: 'sculptra',
    id: 7,
    category: 'injection',
    image: sculptra,
    en: {
      title: 'Sculptra® Poly-L-Lactic Acid',
      subtitle: 'Biostimulatory collagen regenerator for long-lasting structural volume.',
      description: 'A collagen stimulator that gradually restores facial volume, lifts sagging contours, and improves skin quality over time.',
      purpose: 'Rebuilds lost collagen matrix at the cellular level for natural, progressive rejuvenation.',
      mechanism: 'PLLA (Poly-L-Lactic Acid) microparticles trigger your body’s fibroblasts to produce fresh Type I collagen.',
      duration: 'Progressive improvement over 2–3 months; results last over 2 years.',
      features: ['Triggers your own real collagen growth', 'Gradual & extremely natural volume', 'Longest lasting biostimulator (2+ years)', 'Restores deep facial structural loss'],
      indications: ['Sunken cheeks & hollow temples', 'Deep facial sagging & volume loss', 'Crepey skin texture & laxity'],
      process: [
        { title: 'Planning', desc: 'Full facial assessment of structural volume loss.' },
        { title: 'Preparation & Injection', desc: 'Diluted Sculptra injected evenly into deep dermal/subcutaneous layers.' },
        { title: '5-5-5 Massage Rule', desc: 'Post-care guidance: massage 5 mins, 5 times a day, for 5 days.' }
      ],
      faq: [{ q: 'How is Sculptra different from regular HA fillers?', a: 'HA fillers add instant synthetic gel volume; Sculptra stimulates your own real collagen over time.' }],
      meta: { title: 'Sculptra Collagen Stimulator Richmond Hill | Halo Clinic', description: 'Regenerate your natural collagen with Sculptra in Richmond Hill. Long-lasting volume up to 2+ years.' }
    },
    cn: {
      title: 'Sculptra 童颜针（聚左旋乳酸 PLLA）',
      subtitle: '深层刺激胶原蛋白自生，渐进式恢复面部丰盈与年轻结构。',
      description: '通过刺激自身胶原蛋白再生，自然充盈凹陷、紧致松弛皮肤，改善肤质。',
      purpose: '从根源重塑胶原蛋白支架，带来自然持久的抗衰效果。',
      mechanism: 'PLLA（聚左旋乳酸）微球诱导纤维母细胞不断产生新生的I型胶原蛋白。',
      duration: '2-3个月逐渐显效，效果维持长达2年以上。',
      features: ['激发自身真实胶原蛋白生长', '效果渐进极其自然无假面感', '维持时间最长（2年以上）', '改善深层结构性凹陷'],
      indications: ['面颊凹陷、太阳穴凹陷', '面部松弛下垂、轮廓模糊', '皮肤干瘪缺少弹力'],
      process: [
        { title: '结构评估', desc: '评估面部骨骼与脂肪容量缺失区域。' },
        { title: '均匀注射', desc: '稀释配方精准均匀注入深层组织。' },
        { title: '5-5-5按摩指导', desc: '告知术后按摩要领：每天5次，每次5分钟，持续5天。' }
      ],
      faq: [{ q: '童颜针和普通玻尿酸有什么区别？', a: '玻尿酸是物理凝胶即刻填充；童颜针是刺激自身长出真实的胶原蛋白，越久越自然。' }],
      meta: { title: 'Richmond Hill Sculptra童颜针胶原再生 | 2年长效抗衰 | Halo Clinic医美', description: 'Richmond Hill专业童颜针注射，刺激自身胶原蛋白再生，自然丰盈面部凹陷，效果维持长达2年以上。' }
    }
  },
  {
    slug: 'ulthera-prime',
    id: 11,
    category: 'skin',
    image: ultherapy,
    en: {
      title: 'Ulthera® Prime (Ultherapy)',
      subtitle: 'The Gold Standard FDA-Cleared Non-Invasive Ultrasound Skin Lifting.',
      description: 'Marketed as the only non-invasive procedure FDA-cleared to lift skin on the neck, chin, and brow, and improve lines on the décolletage.',
      purpose: 'Deep structural skin lifting and firming targeting the SMAS layer without surgery.',
      mechanism: 'Micro-focused ultrasound (MFU) with real-time DeepSEE™ visualization delivers precise thermal coagulation points at 1.5mm, 3.0mm, and 4.5mm depths.',
      duration: 'Session takes 60–90 mins. Results peak at 2-3 months and last 12-24 months.',
      features: ['FDA-cleared real non-surgical lift', 'Real-time ultrasound visualization', 'Targets deep SMAS surgical layer', 'Single treatment with long-lasting results'],
      indications: ['Sagging jowls & soft jawline', 'Drooping brows & heavy upper eyelids', 'Turkey neck & loose neck skin', 'Chest/décolletage lines'],
      process: [
        { title: 'Cleansing & Mapping', desc: 'Skin marking and real-time ultrasound scanning.' },
        { title: 'Ultrasound Energy Delivery', desc: 'Micro-focused energy delivered precisely into SMAS layer.' },
        { title: 'Immediate Return to Routine', desc: 'Zero downtime; collagen synthesis continues over 6 months.' }
      ],
      faq: [{ q: 'How does Ulthera Prime differ from Thermage?', a: 'Ultherapy lifts deep SMAS layers with ultrasound; Thermage tightens dermal surface layers with RF.' }],
      meta: { title: 'Ulthera Prime (Ultherapy) Richmond Hill | Non-Invasive Lift | Halo Clinic', description: 'Lift sagging skin with Ulthera Prime ultrasound lifting in Richmond Hill. Real-time visualization & FDA-cleared.' }
    },
    cn: {
      title: '美版超声刀 Prime（Ulthera Prime）',
      subtitle: 'FDA认证的非侵入性超声波拉皮金标准，直达SMAS筋膜层筋膜提升。',
      description: '唯一获得FDA批准用于非手术提升面部、颈部和眉头的超声拉皮设备。',
      purpose: '无需手术，深度提升下垂组织，重塑清晰紧致下颌线与颈部线条。',
      mechanism: '微聚焦超声波结合DeepSEE™实时可视化监视，精准作用于1.5mm、3.0mm及4.5mm SMAS筋膜层。',
      duration: '治疗约60-90分钟，2-3个月效果达到巅峰，维持12-24个月。',
      features: ['FDA认证真拉皮提升设备', '实时超声成像精准靶向', '直达外科拉皮SMAS筋膜层', '单次治疗长效维持1-2年'],
      indications: ['下颌线模糊、羊腮肉下垂', '眼皮松弛、眉毛下垂', '双下巴及颈部松弛纹理'],
      process: [
        { title: '超声定位', desc: '实时超声扫描皮肤各层次厚度。' },
        { title: '精准发数打格', desc: '按定制能量方案均匀打入聚焦超声波热凝点。' },
        { title: '术后即刻恢复', desc: '无创无恢复期，胶原蛋白重构持续半月以上。' }
      ],
      faq: [{ q: '超声刀和热玛吉有什么区别？', a: '超声刀偏向深度SMAS筋膜层的“提拉框架”；热玛吉偏向真皮层及表层的“紧致平滑”。两者结合效果更佳。' }],
      meta: { title: 'Richmond Hill 美版超声刀Ulthera Prime | 筋膜层拉皮提升 | Halo Clinic医美', description: 'Richmond Hill官方认证美版超声刀Prime，实时超声显像，精准提升SMAS筋膜层，紧致下颌线与颈部下垂。' }
    }
  },
  {
    slug: 'picosure-pro',
    id: 16,
    category: 'skin',
    image: picosurePro,
    en: {
      title: 'PicoSure® Pro Picosecond Laser',
      subtitle: 'The World’s Premier 755nm Picosecond Laser for Melasma, Pigment & Skin Revitalization.',
      description: 'Delivers 755nm energy in picoseconds to break down pigment, clear sun spots, shrink pores, and treat acne scars with minimal downtime.',
      purpose: 'Targeted removal of stubborn pigmentation, melasma, and comprehensive skin texture refinement.',
      mechanism: 'Photomechanical pressure waves shatter pigment into dust-like particles that are naturally removed by the immune system.',
      duration: '15-30 mins per session. Series of 3-5 sessions recommended for optimal clarity.',
      features: ['FDA-cleared for Melasma, Nevus of Ota, and Hori’s Nevus', '755nm wavelength optimal for pigment', 'Platinum Focus™ lens stimulates collagen', 'Minimal downtime compared to standard lasers'],
      indications: ['Melasma & hormonal spots', 'Sun damage, freckles, & age spots', 'Acne scars & enlarged pores', 'Dull, uneven skin tone'],
      process: [
        { title: 'Cleansing', desc: 'Thorough skin cleansing and eye protection placement.' },
        { title: 'Laser Pass', desc: '755nm picosecond pulses targeted across treatment areas.' },
        { title: 'Cooling & Sunscreen', desc: 'Soothing post-laser balm and medical grade SPF application.' }
      ],
      faq: [{ q: 'Is there downtime after PicoSure Pro?', a: 'Minimal. Mild redness usually subsides within a few hours to 24 hours.' }],
      meta: { title: 'PicoSure Pro Laser Richmond Hill | Melasma & Pigment Removal | Halo Clinic', description: 'Clear melasma, sun spots, and acne scars with PicoSure Pro 755nm picosecond laser in Richmond Hill.' }
    },
    cn: {
      title: '蜂巢皮秒二代 PicoSure® Pro',
      subtitle: '全球首创755nm波长皮秒激光，权威祛黄褐斑、雀斑与蜂巢焕肤。',
      description: '以皮秒级速度发射755nm能量，震碎色素颗粒，改善痤疮疤痕与毛孔粗大，恢复极短。',
      purpose: '精准击退顽固色素沉着、黄褐斑，同时激活胶原蛋白嫩肤。',
      mechanism: '光机械冲击波效应将黑色素震碎成粉尘状，通过机体新陈代谢排出体外。',
      duration: '每次治疗15-30分钟，3-5次为一个疗程。',
      features: ['FDA唯一批准用于治疗黄褐斑的皮秒', '755nm最具针对性的黑色素吸收波长', '白金蜂巢透镜空泡化刺激胶原', '无创高效恢复期极短'],
      indications: ['黄褐斑、晒斑、老年斑、雀斑', '痘印痘坑、毛孔粗大', '肤色暗沉不均'],
      process: [
        { title: '洁面准备', desc: '戴上专业防护眼罩。' },
        { title: '皮秒扫斑', desc: '根据色素深浅调节能量进行平铺与蜂巢模式打格。' },
        { title: '冷敷退红', desc: '涂抹医用修复霜与高倍防晒霜。' }
      ],
      faq: [{ q: '皮秒做完会反黑吗？', a: '755nm皮秒产生极少热效应，反黑概率极低，配合严格防晒效果极佳。' }],
      meta: { title: 'Richmond Hill 蜂巢皮秒二代PicoSure Pro | 祛黄褐斑晒斑痘印 | Halo Clinic医美', description: 'Richmond Hill官方蜂巢皮秒PicoSure Pro治疗，精准去除黄褐斑、晒斑、痘印，收缩毛孔提亮肤色。' }
    }
  },
  {
    slug: 'thermage-flx',
    id: 20,
    category: 'skin',
    image: thermage,
    en: {
      title: 'Thermage® FLX Monopolar RF',
      subtitle: 'FDA-cleared 5th generation Radiofrequency for total face & body skin tightening.',
      description: 'Delivers targeted monopolar radiofrequency energy deep into collagen-rich dermal layers to smooth wrinkles, tighten sagging skin, and define contours.',
      purpose: 'Non-invasive skin tightening and collagen remodeling for eyes, face, neck, and body.',
      mechanism: 'AccuREP™ technology automatically tunes energy for each pulse, heating deep collagen while cooling skin surface.',
      duration: '45–90 mins per treatment. Results continue to improve for 2-6 months and last up to 24 months.',
      features: ['FDA-cleared for eyes, face & body', 'AccuREP™ precision energy calibration', 'Comfort pulse vibration technology', 'Single treatment with zero downtime'],
      indications: ['Wrinkles around eyes & hooded eyelids', 'Sagging cheeks & neck lines', 'Abdomen laxity post-pregnancy'],
      process: [
        { title: 'Grid Mapping', desc: 'Temporary grid printed on skin for uniform energy distribution.' },
        { title: 'RF Pulse Delivery', desc: 'Monopolar RF pulses with integrated cooling and vibration.' },
        { title: 'Post-Care Review', desc: 'Immediate mild firmness; optimal results over 3-6 months.' }
      ],
      faq: [{ q: 'Can Thermage FLX treat the eye area?', a: 'Yes, Thermage has a special Eye Tip FDA-approved for hooded lids and fine eye lines.' }],
      meta: { title: 'Thermage FLX Richmond Hill | Skin Tightening & Wrinkle Reduction | Halo Clinic', description: 'Tighten skin on face, eyes, and body with Thermage FLX Monopolar RF in Richmond Hill.' }
    },
    cn: {
      title: '热玛吉五代 Thermage® FLX',
      subtitle: 'FDA认证第五代单极射频，眼部、面部及身体全方位紧致除皱。',
      description: '单极射频能量深层加热真皮层及皮下组织，刺激胶原蛋白收缩与重构，紧致面部及眼周。',
      purpose: '非手术无创紧致肌肤、抚平皱纹、提升轮廓。',
      mechanism: 'AccuREP™智能技术自动微调每发发数能量，配合震动与表面冷却提升舒适度。',
      duration: '单次45-90分钟，2-6个月持续改善，维持12-24个月。',
      features: ['FDA认证眼面部及身体紧致', 'AccuREP™智能能量校准', '舒适振动冷喷降温系统', '单次治疗零恢复期'],
      indications: ['眼皮松弛下垂、眼周细纹', '面颊松弛、法令纹', '产后腹部及身体皮肤松弛'],
      process: [
        { title: '打格印纸', desc: '转印印纸印出定位格子，确保能量均匀覆盖。' },
        { title: '射频发射', desc: '贴合皮肤打入热玛吉射频发数（伴随震动冷却）。' },
        { title: '完成离开', desc: '即刻感觉收紧感，完全无恢复期。' }
      ],
      faq: [{ q: '热玛吉可以做眼周吗？', a: '可以，热玛吉拥有FDA批准的眼部专用探头（Eye Tip），专门解决眼皮松弛与眼纹。' }],
      meta: { title: 'Richmond Hill 热玛吉五代Thermage FLX | 面部眼部紧致除皱 | Halo Clinic医美', description: 'Richmond Hill正版热玛吉五代FLX，眼面部及身体无创紧致除皱，AccuREP智能射频拉皮。' }
    }
  },
  {
    slug: 'potenza-rf-microneedling',
    id: 12,
    category: 'skin',
    image: potenza,
    en: {
      title: 'Potenza™ RF Microneedling',
      subtitle: 'Customizable Radiofrequency Microneedling for Acne Scars, Pores & Skin Tightening.',
      description: 'Combines ultrafine microneedling with monopolar and bipolar RF energy to trigger deep structural collagen synthesis.',
      purpose: 'Smooths acne scars, refines skin texture, minimizes pores, and tightens skin.',
      mechanism: 'Microneedles penetrate skin and emit RF heat at precise depths, stimulating collagen and elastin production.',
      duration: '30-60 mins per session. 3 sessions recommended for optimal scar repair.',
      features: ['Monopolar & Bipolar dual RF modes', 'Tiger Tip™ technology treats multiple depths', 'Ideal for stubborn acne scars & pores', 'Customizable tip configurations'],
      indications: ['Acne scarring & textural irregularities', 'Enlarged pores', 'Mild to moderate skin laxity'],
      process: [
        { title: 'Numbing', desc: 'Topical anesthetic for 30 minutes.' },
        { title: 'RF Microneedling', desc: 'Potenza handpiece passes across treatment zone.' },
        { title: 'Soothing Serum', desc: 'Application of calmative growth factors or exosomes.' }
      ],
      faq: [{ q: 'How long is recovery after Potenza?', a: 'Mild redness for 24-48 hours, easily covered with tinted SPF.' }],
      meta: { title: 'Potenza RF Microneedling Richmond Hill | Acne Scars & Tightening | Halo Clinic', description: 'Smooth acne scars and tighten skin with Potenza RF Microneedling in Richmond Hill.' }
    },
    cn: {
      title: ' Potenza 黄金微针（Potenza™ RF Microneedling）',
      subtitle: '单极/双极双频微针射频，权威修复痘坑痘印、收缩毛孔与紧致。',
      description: '将微针与射频能量结合，精准作用于不同皮肤深度，刺激胶原蛋白与弹性蛋白重塑。',
      purpose: '填平凹陷性痘坑、平滑皮肤纹理、收紧毛孔与轻中度松弛。',
      mechanism: '微针穿透表皮后释放RF热能，在真皮层引发热凝固反应，激发自体创伤修复。',
      duration: '约30-60分钟，建议3次作为一个疗程。',
      features: ['单极与双极双模式射频', 'Tiger Tip™绝缘微针分层加热', '痘坑痘印与毛孔修复利器', '深度发数可定制'],
      indications: ['痘坑、痘印、创伤性疤痕', '毛孔粗大、油光肤质', '皮肤松弛与粗糙纹理'],
      process: [
        { title: '表面麻醉', desc: '敷麻膏30分钟提升过程舒适度。' },
        { title: '黄金微针操作', desc: '按制定参数打入目标区域。' },
        { title: '高浓缩外泌体/修复导入', desc: '利用刚打开的微通道高效吸收修复精华。' }
      ],
      faq: [{ q: '恢复期需要几天？', a: '通常仅有24-48小时轻微泛红，不影响正常社交。' }],
      meta: { title: 'Richmond Hill Potenza黄金微针射频 | 修复痘坑痘印收缩毛孔 | Halo Clinic医美', description: 'Richmond Hill专业Potenza黄金微针射频治疗，高效修复痘坑痘印、收缩毛孔与紧致皮肤。' }
    }
  },
  {
    slug: 'hydrafacial',
    id: 9,
    category: 'skin',
    image: hydrafacial,
    en: {
      title: 'HydraFacial® MD',
      subtitle: 'Patented Vortex-Fusion® deep cleansing, extraction, and antioxidant hydration.',
      description: 'Cleanses, exfoliates, extracts impurities, and hydrates skin with customized serums in a soothing 30-45 minute session.',
      purpose: 'Unclogs pores, removes blackheads, and imparts an instant luminous red-carpet glow.',
      mechanism: 'Vortex-Fusion® suction gently painlessly extracts congestion while delivering nourishing peptides and hyaluronic acid.',
      duration: '30–45 mins. Zero downtime with instant radiance.',
      features: ['Pain-free blackhead extraction', 'Exfoliates dead skin cells', 'Deep serum hydration infusion', 'Instant red-carpet glow'],
      indications: ['Congested pores & blackheads', 'Dullness & rough skin texture', 'Oily or acne-prone skin'],
      process: [
        { title: 'Cleanse & Peel', desc: 'Gentle exfoliation with glycolic/salicylic acid blend.' },
        { title: 'Extract & Hydrate', desc: 'Painless vortex suction removes impurities.' },
        { title: 'Fuse & Protect', desc: 'Antioxidants and peptides infused for immediate radiant glow.' }
      ],
      faq: [{ q: 'Can I wear makeup right after HydraFacial?', a: 'Yes, though most clients love their natural glow so much they go bare-faced!' }],
      meta: { title: 'HydraFacial Richmond Hill | Deep Cleansing & Glow | Halo Clinic', description: 'Deeply cleanse and hydrate your skin with genuine HydraFacial in Richmond Hill.' }
    },
    cn: {
      title: '海菲秀（HydraFacial® MD）',
      subtitle: '专利Vortex-Fusion®涡旋技术，深层清洁、去黑头与精华导入。',
      description: '非侵入性多步骤小气泡清洁护理，清洁毛孔、去角质、抽吸黑头并注入抗氧化精华。',
      purpose: '解决毛孔堵塞、黑头粉刺，即刻打造红毯级水光肌肤。',
      mechanism: '螺旋涡旋负压吸引温和无痛清除毛孔脏污，同时无缝注入高浓度透明质酸与胜肽。',
      duration: '30-45分钟，零恢复期，做完即刻发光。',
      features: ['无痛吸出黑头油脂', '温和去角质焕肤', '深层补水精华导入', '做完即刻水光透亮'],
      indications: ['毛孔粗大、黑头白头多', '皮肤暗沉粗糙', '油性及痘痘肌预护理'],
      process: [
        { title: '净颜软化', desc: '温和剥脱老废角质。' },
        { title: '涡旋抽取', desc: '无痛负压吸出毛孔深层油脂脏污。' },
        { title: '滋养防护', desc: '导入抗氧化及多肽高能精华。' }
      ],
      faq: [{ q: '做完做完可以马上化妆吗？', a: '可以，做完海菲秀皮肤水润通透，底妆会极其服帖。' }],
      meta: { title: 'Richmond Hill 海菲秀HydraFacial正版 | 深度清洁去黑头水光 | Halo Clinic医美', description: 'Richmond Hill正版海菲秀HydraFacial清洁护理，无痛去黑头、深层补水、提亮肤色。' }
    }
  },
  {
    slug: 'bbl-hero',
    id: 10,
    category: 'skin',
    image: bblHero,
    en: {
      title: 'BBL® HERO™ Photo-Rejuvenation',
      subtitle: 'High-speed BroadBand Light for sun spots, redness, rosacea, and skin tone evening.',
      description: 'Delivers 4x speed and 3x peak power to target pigments, broken capillaries, and redness across face and body.',
      purpose: 'Eliminates sun damage, reduces facial redness/rosacea, and restores youthful skin tone.',
      mechanism: 'BroadBand Light energy is absorbed by melanin and hemoglobin, converting light to heat to clear target chromophores.',
      duration: '20-45 mins per session. 3-4 sessions recommended for crystal clear skin.',
      features: ['4x faster treatment speed with HERO technology', 'Targets sun spots, age spots & freckles', 'Clears broken capillaries & rosacea', 'Forever Young BBL™ anti-aging protocol'],
      indications: ['Sun damage & age spots', 'Rosacea & facial redness', 'Uneven tone & hyperpigmentation'],
      process: [
        { title: 'Cooling Gel Application', desc: 'Cool gel applied for maximum comfort.' },
        { title: 'Light Pulses', desc: 'Rapid HERO pulses passed across face/body.' },
        { title: 'Post-Care', desc: 'Pigment darkens temporarily (coffee-ground effect) then sloughs off in 5-7 days.' }
      ],
      faq: [{ q: 'What happens to sun spots after treatment?', a: 'They temporarily darken like coffee grounds and naturally flake off over 5–7 days.' }],
      meta: { title: 'BBL HERO Photofacial Richmond Hill | Sun Spots & Redness | Halo Clinic', description: 'Clear sun spots and facial redness with BBL HERO Broadband Light in Richmond Hill.' }
    },
    cn: {
      title: ' BBL HERO 光子嫩肤（BroadBand Light）',
      subtitle: '最强宽光谱光子技术，高效祛斑、褪红、改善酒糟鼻与全脸提亮。',
      description: '4倍速度与3倍峰值功率，精准靶向黑色素与红血丝，全面改善光老化与肤色不均。',
      purpose: '消除日晒斑、雀斑，收缩红血丝，使皮肤恢复年轻透亮状态。',
      mechanism: '宽光谱强脉冲光选择性作用于黑色素与血红蛋白，热凝固后随新陈代谢自然排出。',
      duration: '全脸治疗约20-45分钟，建议3-4次作为一个周期。',
      features: ['HERO高速滑动模式更快更舒适', '高效祛除晒斑老年斑雀斑', '显著改善面部红血丝与酒渣鼻', 'Forever Young基因级抗衰'],
      indications: ['晒斑、老年斑、色素沉着', '红血丝、敏感泛红、酒糟鼻', '肤色暗沉光老化'],
      process: [
        { title: '涂抹冷凝胶', desc: '敷上冰爽传导凝胶保护表皮。' },
        { title: '光子打格扫打', desc: '配合蓝宝石冷却头进行快速光子打格。' },
        { title: '冷敷防晒', desc: '斑点处可能呈现微暗结痂，5-7天自然脱落。' }
      ],
      faq: [{ q: '打完后斑点会怎样？', a: '色素斑点短时间内会微微变暗呈咖啡渣状，约5-7天洗脸时自然脱落。' }],
      meta: { title: 'Richmond Hill BBL HERO光子嫩肤 | 祛晒斑祛红血丝提亮 | Halo Clinic医美', description: 'Richmond Hill BBL HERO光子嫩肤，快速淡化色斑、修复面部红血丝、提亮整体肤色。' }
    }
  },
  {
    slug: 'belkyra-kybella',
    id: 6,
    category: 'injection',
    image: belkyra,
    en: {
      title: 'Belkyra® (Kybella®)',
      subtitle: 'FDA-cleared permanent double-chin fat cell dissolution.',
      description: 'An injectable treatment that permanently destroys fat cells under the chin (submental fullness) to contour the jawline.',
      purpose: 'Eliminates double chin fat without surgery or liposuction.',
      mechanism: 'Deoxycholic acid breaks down fat cell membranes; destroyed cells are permanently cleared by metabolic pathways.',
      duration: '15–30 mins. 2–4 sessions recommended for defined jawline contours.',
      features: ['Permanent fat cell destruction', 'Non-surgical double chin solution', 'Sharpens jawline definition'],
      indications: ['Submental fat / Double chin', 'Full jawline area'],
      process: [
        { title: 'Mapping', desc: 'Grid marking of submental fat compartment.' },
        { title: 'Injections', desc: 'Series of small micro-injections directly into fat pad.' }
      ],
      faq: [{ q: 'Is the fat reduction permanent?', a: 'Yes, once fat cells are destroyed they can no longer store fat.' }],
      meta: { title: 'Belkyra Kybella Double Chin Treatment Richmond Hill | Halo Clinic', description: 'Permanently dissolve double chin fat with Belkyra (Kybella) injections in Richmond Hill.' }
    },
    cn: {
      title: 'Belkyra® 溶脂针（Kybella）',
      subtitle: 'FDA批准双下巴溶脂针，永久破坏脂肪细胞。',
      description: '非手术双下巴消除疗法，通过注射去氧胆酸永久溶解双下巴及局部脂肪。',
      purpose: '消除顽固双下巴脂肪，打造清晰紧致的下颌线条。',
      mechanism: '去氧胆酸击碎脂肪细胞膜，溶解后的脂肪经人体新陈代谢永久排出。',
      duration: '每次15-30分钟，通常2-4次达到理想雕塑效果。',
      features: ['永久性破坏脂肪细胞', '免手术免抽脂无瘢痕', '重塑精细紧致下颌线'],
      indications: ['双下巴脂肪堆积', '下颌线局部脂肪'],
      process: [
        { title: '打格印网', desc: '标记双下巴脂肪注射点。' },
        { title: '精准注射', desc: '均匀小剂量注射入脂肪层。' }
      ],
      faq: [{ q: '效果是永久的吗？', a: '是的，被溶解破坏的脂肪细胞无法再生或重新储存脂肪。' }],
      meta: { title: 'Richmond Hill Belkyra溶脂针双下巴 | 永久瘦下颌线 | Halo Clinic医美', description: 'Richmond Hill官方Belkyra溶脂针，非手术永久消除双下巴，打造精致清晰下颌线。' }
    }
  },
  {
    slug: 'radiesse',
    id: 8,
    category: 'injection',
    image: radiesse,
    en: {
      title: 'Radiesse® Biostimulatory Filler',
      subtitle: 'Calcium Hydroxylapatite (CaHA) for instant lift and collagen regeneration.',
      description: 'Provides immediate volumizing lift while actively stimulating your body’s natural collagen and elastin over time.',
      purpose: 'Contouring jawline, hands, and lower face volume loss with biostimulatory action.',
      mechanism: 'CaHA microspheres form a scaffolding that supports immediate volume and stimulates neocollagenesis.',
      duration: 'Immediate lift lasting 12–18 months with continuous skin quality improvement.',
      features: ['Immediate volume + long-term collagen', 'Excellent structural jawline & hand rejuvenation', 'Biostimulatory CaHA formula'],
      indications: ['Weak jawline & chin', 'Aging hands with visible veins/tendons', 'Deep lower face contours'],
      process: [
        { title: 'Planning', desc: 'Mapping injection zones.' },
        { title: 'Injection', desc: 'Cannula placement of Radiesse.' }
      ],
      faq: [{ q: 'How long does Radiesse last?', a: 'Typically 12-18 months, with ongoing skin quality benefits.' }],
      meta: { title: 'Radiesse Filler Richmond Hill | Jawline & Hand Rejuvenation | Halo Clinic', description: 'Instant lift and collagen stimulation with Radiesse in Richmond Hill.' }
    },
    cn: {
      title: 'Radiesse® 微晶瓷/少女针',
      subtitle: '羟基磷灰石钙（CaHA）即刻支撑与长效胶原蛋白再生。',
      description: '提供即刻支撑立体的充盈效果，同时持续诱导自体胶原蛋白与弹性纤维新生。',
      purpose: '精细雕塑下颌线、下巴及手部重焕年轻活力。',
      mechanism: 'CaHA微球形成网状支架提供物理支撑，并不断刺激胶原母细胞生长。',
      duration: '即刻显效，维持12-18个月。',
      features: ['即刻充盈 + 持续胶原再生', '骨性支撑力强不移位', '手部抗衰回春首选'],
      indications: ['下颌线不够清晰、下巴后缩', '手部皮肤干瘪血管青筋明显'],
      process: [
        { title: '方案设计', desc: '评估骨骼支撑点。' },
        { title: '钝针注射', desc: '舒适分层定点铺设。' }
      ],
      faq: [{ q: '能维持多久？', a: '通常维持12-18个月，胶原重塑效果显著。' }],
      meta: { title: 'Richmond Hill Radiesse微晶瓷少女针 | 骨性支撑下颌线 | Halo Clinic医美', description: 'Richmond Hill Radiesse微晶瓷注射，提供强劲骨性支撑与胶原再生。' }
    }
  },
  {
    slug: 'harmonyca',
    id: 18,
    category: 'injection',
    image: harmonyca,
    en: {
      title: 'HArmonyCa™ Hybrid Injectable',
      subtitle: 'Dual-effect hybrid combining Hyaluronic Acid (HA) and Calcium Hydroxyapatite (CaHA).',
      description: 'Combines immediate HA lifting effect with long-term CaHA collagen stimulation for structural skin tightening.',
      purpose: 'Hybrid facial tightening, lateral face lift, and structural skin architecture rebuild.',
      mechanism: 'HA provides instant volume and hydration; CaHA microspheres trigger deep long-term collagen remodeling.',
      duration: 'Immediate lift; results improve for months and last up to 18-24 months.',
      features: ['Dual-action HA + CaHA hybrid formula', 'Immediate lifting + ongoing collagen synthesis', 'Improves skin density & laxity'],
      indications: ['Lateral cheek laxity & lower face sagging', 'Loss of skin firmness'],
      process: [
        { title: 'Assessment', desc: 'Evaluating lateral vectors of the face.' },
        { title: 'Cannula Injection', desc: 'Precision fan-injection technique.' }
      ],
      faq: [{ q: 'What makes HArmonyCa unique?', a: 'It is the first hybrid injectable combining instant HA lift with long-term CaHA biostimulation.' }],
      meta: { title: 'HArmonyCa Hybrid Injectable Richmond Hill | Halo Clinic', description: 'Experience the dual-power HA + CaHA hybrid lift with HArmonyCa in Richmond Hill.' }
    },
    cn: {
      title: 'HArmonyCa™ 双效混和针',
      subtitle: '玻尿酸 (HA) + 羟基磷灰石钙 (CaHA) 双效合一新型注射。',
      description: '结合玻尿酸的即刻提升与CaHA的长效胶原再生，重建紧致皮肤支架。',
      purpose: '侧脸外侧提拉、改善皮肤松弛与增强皮肤厚度与弹性。',
      mechanism: '玻尿酸即刻充盈物理提拉；CaHA微球持续刺激真皮层胶原长效新生。',
      duration: '即刻见效，胶原重塑可持续18-24个月。',
      features: ['HA+CaHA独创双效混合成分', '即刻提拉与持久胶原新生双重保障', '显著提升皮肤密度与紧致度'],
      indications: ['中下面部及侧脸松弛', '皮肤缺乏韧性与弹性'],
      process: [
        { title: '提拉矢量设计', desc: '评估面部力学提升点。' },
        { title: '钝针平铺', desc: '微创扇形平铺注入。' }
      ],
      faq: [{ q: 'HArmonyCa有什么独特之处？', a: '它是全球首款将玻尿酸即刻丰盈与CaHA长效再生结合的双效产品。' }],
      meta: { title: 'Richmond Hill HArmonyCa双效混合针 | 玻尿酸+胶原再生 | Halo Clinic医美', description: 'Richmond Hill HArmonyCa双效针，同时实现即刻玻尿酸提升与长效胶原再生。' }
    }
  },
  {
    slug: 'instalift-thread-lift',
    id: 19,
    category: 'injection',
    image: instalift,
    en: {
      title: 'Silhouette InstaLift® Thread Lift',
      subtitle: 'Absorbable micro-cone thread technology for non-surgical facial lifting.',
      description: 'Minimally invasive micro-suspension technology using absorbable PLGA threads with bidirectional cones to lift sagging facial tissue.',
      purpose: 'Instant mechanical lift of cheeks, jowls, and mid-face without surgery.',
      mechanism: 'Absorbable threads lift deep tissue while micro-cones stimulate ongoing collagen renewal as they dissolve.',
      duration: 'Immediate lift visible; results last 12–18 months.',
      features: ['Instant non-surgical face lift', 'Bidirectional micro-cone fixation', 'Stimulates deep collagen during thread absorption'],
      indications: ['Mid-face sagging & nasolabial folds', 'Jowl formation & lower cheek descent'],
      process: [
        { title: 'Local Anesthesia', desc: 'Targeted entry and exit point numbing.' },
        { title: 'Thread Placement', desc: 'Micro-threads inserted to lift deep tissue vector.' }
      ],
      faq: [{ q: 'Are the threads absorbable?', a: 'Yes, they naturally dissolve completely within 6-12 months while collagen remains.' }],
      meta: { title: 'Silhouette InstaLift Thread Lift Richmond Hill | Halo Clinic', description: 'Non-surgical thread lift with Silhouette InstaLift in Richmond Hill.' }
    },
    cn: {
      title: 'Silhouette InstaLift® 埋线提升（线雕拉皮）',
      subtitle: '可吸收微椎体线雕技术，无创物理提拉下垂组织。',
      description: '微创微悬吊技术，采用双向锥体可吸收线材，即刻机械提拉中下面部松弛组织。',
      purpose: '无需手术，即刻物理提升苹果肌、口角囊袋及下颌线。',
      mechanism: '可吸收线材提供即刻张力提拉，微椎体在降解过程中持续诱导胶原蛋白重构。',
      duration: '即刻见效，提升与胶原重构效果维持12-18个月。',
      features: ['非手术即刻物理拉皮提升', '专利双向锥体固定不滑脱', '线材吸收过程持续刺激胶原'],
      indications: ['苹果肌下垂、法令纹加深', '口角囊袋、面颊下垂'],
      process: [
        { title: '局麻准备', desc: '在进针与出针点进行局麻。' },
        { title: '精准埋线提拉', desc: '按提升矢量植入线材并压平固定。' }
      ],
      faq: [{ q: '线材会被吸收吗？', a: '会，线材在6-12个月内完全吸收为水和二氧化碳，留下的胶原支架继续维持效果。' }],
      meta: { title: 'Richmond Hill InstaLift线雕埋线拉皮 | 微创紧致提升 | Halo Clinic医美', description: 'Richmond Hill InstaLift正版线雕提升，即刻物理提拉中下面部，无创恢复轮廓年轻。' }
    }
  },
  {
    slug: 'microneedling-treatments',
    id: 17,
    category: 'skin',
    image: microneedlingImage,
    en: {
      title: 'Microneedling Infusion Therapy',
      subtitle: 'PDRN Salmon DNA | Lumiere Brightening | HA Hydration Infusion',
      description: 'Micro-channels promote collagen production and deliver active PDRN, hyaluronic acid, and brightening cocktails deep into skin.',
      purpose: 'Improves skin repair, elasticity, hydration, and radiance.',
      mechanism: 'Precision micro-needles trigger wound-healing collagen while active serums absorb 1000x deeper.',
      duration: '45-60 mins. Results appear in weeks and last 3-6 months.',
      features: ['PDRN Salmon DNA for cellular repair', 'Deep hydration & plumping', 'Collagen & elastin stimulation'],
      subServices: [
        { name: 'PDRN Microneedling', benefits: ['Salmon DNA triggers rapid tissue repair', 'Strengthens damaged skin barrier'] },
        { name: 'Lumiere Brightening Microneedling', benefits: ['Infuses antioxidants & vitamins', 'Fades dullness and evens tone'] },
        { name: 'HA Infusion Microneedling', benefits: ['Intense deep dermal hydration', 'Plumps fine lines instantly'] }
      ],
      indications: ['Acne scarring & uneven skin', 'Dehydrated, thin, or damaged skin'],
      process: [{ title: 'Numbing & Infusion', desc: 'Micro-channels infused with targeted serum.' }],
      faq: [{ q: 'What is PDRN?', a: 'PDRN (Polydeoxyribonucleotide) is derived from salmon DNA, proven to accelerate skin tissue repair.' }],
      meta: { title: 'PDRN & Microneedling Richmond Hill | Lumiere Infusion | Halo Clinic', description: 'Targeted microneedling infusion with PDRN and HA in Richmond Hill.' }
    },
    cn: {
      title: '微针水光与PDRN三文鱼DNA导入（Microneedling）',
      subtitle: 'PDRN三文鱼修复水光 | Lumiere亮白微针 | 纯玻尿酸水光微针',
      description: '打开皮肤微通道，刺激胶原自生，并将PDRN、透明质酸及亮白成分深层导入真皮。',
      purpose: '全面修复受损屏障、淡化痘印、深层补水与提升皮肤厚度。',
      mechanism: '微针微创刺激创伤愈合反应，配合高能营养成分直达基层。',
      duration: '45-60分钟，效果维持3-6个月。',
      features: ['PDRN三文鱼DNA强效修复屏障', '深层补水充盈', '刺激胶原蛋白与弹力蛋白'],
      subServices: [
        { name: 'PDRN 三文鱼DNA微针', benefits: ['三文鱼DNA核苷酸加速组织修复', '增厚敏感脆弱屏障'] },
        { name: 'Lumiere 亮白焕彩微针', benefits: ['注入复合维C与抗氧化精华', '退黄淡斑提亮肤色'] },
        { name: 'HA 高浓度玻尿酸微针', benefits: ['深层补充极小分子玻尿酸', '平滑干纹恢复水润'] }
      ],
      indications: ['痘印痘坑、屏障受损泛红', '干燥缺少弹力'],
      process: [{ title: '敷麻与微针导入', desc: '微针均匀打格同时导入高浓缩精华。' }],
      faq: [{ q: '什么是PDRN？', a: 'PDRN是提取自三文鱼DNA的多聚核苷酸，被医学界证实能强力诱导细胞创伤修复。' }],
      meta: { title: 'Richmond Hill PDRN三文鱼水光微针 | 修复屏障淡化痘印 | Halo Clinic医美', description: 'Richmond Hill PDRN三文鱼DNA微针导入，强效修复敏感屏障、淡化痘印与深层补水。' }
    }
  },
  {
    slug: 'spectrum-therapy',
    id: 13,
    category: 'skin',
    image: skincare,
    en: {
      title: 'Spectrum Therapy™ Light Treatment',
      subtitle: 'Photobiomodulation with Red, Blue, and Yellow LED light.',
      description: 'Cool LED wavelengths target acne bacteria, soothe inflammation, and stimulate collagen for radiant, healthy skin.',
      purpose: 'Acne prevention, post-procedure healing, and calmative skin recovery.',
      mechanism: 'Non-thermal LED light initiates photobiomodulation to accelerate cellular metabolism.',
      duration: '15-20 mins. Often added to other treatments for boosted recovery.',
      features: ['Blue light for acne bacteria', 'Red light for collagen & healing', 'Yellow light for soothing redness'],
      indications: ['Active acne', 'Post-laser redness or sunburn', 'Sensitive skin inflammation'],
      process: [{ title: 'LED Treatment', desc: 'Relax under LED canopy for 15-20 mins.' }],
      faq: [{ q: 'Is LED light safe?', a: 'Completely safe, painless, and UV-free.' }],
      meta: { title: 'Spectrum LED Light Therapy Richmond Hill | Halo Clinic', description: 'Acne and healing Spectrum LED light therapy in Richmond Hill.' }
    },
    cn: {
      title: 'Spectrum Therapy™ 光谱修护光疗',
      subtitle: '红光、蓝光、黄光三色光生物调节与抗炎舒缓。',
      description: '采用特定波长的冷光照射，杀灭痘痘细菌、消除炎症、促进创伤愈合与胶原生成。',
      purpose: '治疗痤疮痘痘、医美术后镇静退红、修复受损屏障。',
      mechanism: 'LED光子触发细胞内线粒面体ATP能量合成，加速新陈代谢。',
      duration: '15-20分钟，常作为激光或微针后的黄金修复项目。',
      features: ['蓝光高效杀灭痤疮丙酸杆菌', '红光促进创伤愈合与胶原蛋白', '黄光镇静退红舒缓过敏'],
      indications: ['炎性痘痘、粉刺', '晒伤、激光或微针术后泛红'],
      process: [{ title: '光谱照射', desc: '佩戴护眼罩进行15-20分钟舒适照光。' }],
      faq: [{ q: '会有紫外线伤害吗？', a: '完全没有，LED红蓝光属于纯净冷光，不含紫外线。' }],
      meta: { title: 'Richmond Hill LED红蓝光修护光疗 | 祛痘抗炎术后退红 | Halo Clinic医美', description: 'Richmond Hill Spectrum LED光谱光疗，专业杀菌祛痘、舒缓敏感泛红与术后快速修复。' }
    }
  },
  {
    slug: 'visia-skin-analysis',
    id: 14,
    category: 'skin',
    image: visia,
    en: {
      title: 'Visia® Complexion Analysis',
      subtitle: 'Scientific 3D skin diagnostic imaging for tailored treatment plans.',
      description: 'Provides multi-spectral imaging to analyze spots, pores, wrinkles, UV damage, bacteria, and vascular zones.',
      purpose: 'Scientific assessment of superficial and deep skin conditions.',
      mechanism: 'Cross-polarized and UV lighting capture sub-surface skin metrics.',
      duration: '15 minutes process.',
      features: ['Quantifies deep UV damage & spots', 'Analyzes skin age & pore congestion', 'Customized treatment roadmap'],
      indications: ['Consultation baseline prior to medical aesthetics'],
      process: [{ title: 'Imaging & Report', desc: 'High-resolution photo capture and detailed report discussion.' }],
      faq: [{ q: 'Why is Visia analysis recommended?', a: 'It reveals deep sub-surface issues (like hidden UV damage) before they surface.' }],
      meta: { title: 'Visia Skin Analysis Richmond Hill | Halo Clinic', description: 'Get a scientific 3D Visia skin diagnosis in Richmond Hill.' }
    },
    cn: {
      title: 'Visia® 3D 皮肤检测（Visia Skin Analysis）',
      subtitle: '高分辨率多光谱皮肤诊断，科学量化隐性肌底问题。',
      description: '通过标准光、偏振光及UV光全方位检测斑点、毛孔、皱纹、紫外线斑、卟啉细菌及红血丝。',
      purpose: '客观量化皮肤现状，为医美方案制定提供科学依据。',
      mechanism: '多光谱成像结合数据库对比分析表皮与真皮深层状况。',
      duration: '全程约15分钟。',
      features: ['精准检测日光斑与深层色素', '评估皮肤真实年龄与毛孔堵塞', '量化追踪医美前后疗效对比'],
      indications: ['所有医美项目前的科学评估'],
      process: [{ title: '拍照与报告解读', desc: '固定位置多角度拍照并生成深度分析报告。' }],
      faq: [{ q: '为什么要先做Visia检测？', a: '能提前看清肉眼看不到的深层紫外线损伤与隐性斑点，让治疗更精准。' }],
      meta: { title: 'Richmond Hill Visia皮肤检测 | 科学诊断肤质 | Halo Clinic医美', description: 'Richmond Hill Visia 3D皮肤检测，精准评估表皮与真皮深层斑点、毛孔与衰老度。' }
    }
  },
  {
    slug: 'skin-tag-removal',
    id: 15,
    category: 'skin',
    image: skinTagRemoval,
    en: {
      title: 'Skin Tag & Mole Removal',
      subtitle: 'Precision Hyfrecator electrocoagulation for moles, warts, and skin tags.',
      description: 'Safe and swift thermal electrocoagulation removal of skin tags, junctional moles, and benign lesions.',
      purpose: 'Removes unwanted skin growths cleanly with minimal scabbing.',
      mechanism: 'Hyfrecator micro-heat carbonizes target tissue without affecting surround skin.',
      duration: '15-30 mins.',
      features: ['Instant precise removal', 'Minimal discomfort', 'Fast healing (1-2 weeks)'],
      indications: ['Neck & facial skin tags', 'Benign moles & warts'],
      process: [{ title: 'Cauterization', desc: 'Precision micro-heat application.' }],
      faq: [{ q: 'How long does healing take?', a: 'Small scabs naturally fall off within 7-14 days.' }],
      meta: { title: 'Skin Tag & Mole Removal Richmond Hill | Halo Clinic', description: 'Safe and precise skin tag removal in Richmond Hill.' }
    },
    cn: {
      title: '皮赘/痣/扁平疣祛除（Skin Tag Removal）',
      subtitle: 'Hyfrecator 高频电凝精准祛除皮赘、色素痣与疣体。',
      description: '采用高频电灼原理，快速安全气化祛除颈部与面部皮赘、痣及良性赘生物。',
      purpose: '干净无痛祛除影响美观的皮肤赘生物。',
      mechanism: '高频微热能使赘生物瞬间碳化，精准不伤周围健康肌肤。',
      duration: '15-30分钟。',
      features: ['即刻精准祛除', '微创无痛', '恢复快结痂7-14天脱落'],
      indications: ['颈部/腋下皮赘', '面部良性痣与疣体'],
      process: [{ title: '精细电灼', desc: '微点精准气化碳化。' }],
      faq: [{ q: '多久能恢复？', a: '结痂通常在7-14天内自然脱落。' }],
      meta: { title: 'Richmond Hill 点痣祛皮赘扁平疣 | 微创无痛电凝 | Halo Clinic医美', description: 'Richmond Hill专业点痣祛皮赘，高频电凝无痛精准祛除面部颈部痣与赘生物。' }
    }
  },
  {
    slug: 'dermal-fillers-body',
    id: '4b',
    category: 'body',
    image: bodyfiller,
    en: {
      title: 'Body Dermal Fillers',
      subtitle: 'Juvederm | Revanesse Contour XL for Body Volumization & Contour.',
      description: 'High-density hyaluronic acid volumizers for buttock reshaping, hip dip correction, and body smoothing.',
      purpose: 'Restores curvature and smooths body contours without surgery.',
      mechanism: 'High-viscosity HA filler injected into body planes for structural volume.',
      duration: 'Immediate results lasting 12-24 months.',
      features: ['Instant body curve enhancement', 'Non-surgical hip dip filler', 'Safe & biocompatible'],
      indications: ['Hip dips', 'Buttock flat areas', 'Body skin depression'],
      process: [{ title: 'Mapping & Injection', desc: 'Precision body cannula injection.' }],
      faq: [{ q: 'How long do body fillers last?', a: '12 to 24 months depending on area.' }],
      meta: { title: 'Body Fillers & Hip Dip Filler Richmond Hill | Halo Clinic', description: 'Non-surgical body contouring with body fillers in Richmond Hill.' }
    },
    cn: {
      title: '身体玻尿酸填充（Body Dermal Fillers）',
      subtitle: 'Revanesse Contour XL 高粘度身体大分子玻尿酸。',
      description: '专为身体塑形设计的大分子玻尿酸，充盈臀凹陷（Hip Dips）、塑造丰满曲线。',
      purpose: '无需手术，快速修正臀部凹陷与改善身体轮廓。',
      mechanism: '高粘弹性透明质酸注入身体深层组织提供强力支撑。',
      duration: '即刻显效，维持12-24个月。',
      features: ['非手术丰臀修饰Hip Dips', '即刻展现S曲线', '安全高相容性'],
      indications: ['臀部两侧凹陷（Hip Dips）', '臀部扁平'],
      process: [{ title: '画线与注射', desc: '钝针安全分层铺设。' }],
      faq: [{ q: '身体玻尿酸能维持多久？', a: '通常维持12至24个月。' }],
      meta: { title: 'Richmond Hill 身体玻尿酸丰臀填充 | 修饰Hip Dips凹陷 | Halo Clinic医美', description: 'Richmond Hill身体玻尿酸填充，非手术修饰臀部凹陷（Hip Dips），塑造完美曲线。' }
    }
  },
  {
    slug: 'belkyra-kybella-body',
    id: '6b',
    category: 'body',
    image: belkyrabody,
    en: {
      title: 'Body Belkyra® (Kybella®) Fat Dissolving',
      subtitle: 'Targeted permanent fat cell reduction for bra fat, upper arm bulge, and knee pads.',
      description: 'Deoxycholic acid injections permanently break down targeted stubborn body fat pockets.',
      purpose: 'Spot reduction for small, stubborn stubborn fat zones.',
      mechanism: 'Destroys fat cell membranes naturally eliminated by the body.',
      duration: 'Permanent fat reduction after 2-4 sessions.',
      features: ['Permanent fat cell destruction', 'Targets bra fat & arm fat', 'No surgery or downtime'],
      indications: ['Bra bulge fat', 'Upper arm localized fat', 'Above-knee fat pockets'],
      process: [{ title: 'Injections', desc: 'Targeted micro-injections in grid pattern.' }],
      faq: [{ q: 'Is fat removal permanent?', a: 'Yes, destroyed fat cells are permanently removed.' }],
      meta: { title: 'Body Belkyra Fat Dissolving Richmond Hill | Halo Clinic', description: 'Target stubborn body fat pockets with Belkyra body溶脂 in Richmond Hill.' }
    },
    cn: {
      title: '身体局部溶脂针（Belkyra Body）',
      subtitle: '针对副乳、手臂拜拜肉、副乳及膝盖脂肪的永久溶脂。',
      description: '去氧胆酸精准注射于身体局部顽固脂肪堆积处，永久破坏脂肪细胞。',
      purpose: '消除抽脂无法精细雕塑的小块顽固脂肪。',
      mechanism: '溶解细胞膜使脂肪自然代谢排除。',
      duration: '2-4次疗程后永久有效。',
      features: ['永久破坏局部脂肪', '精准消除副乳与拜拜肉', '无需手术'],
      indications: ['副乳脂肪', '手臂拜拜肉', '膝盖上方脂肪堆积'],
      process: [{ title: '打格注射', desc: '网格定位均匀微量注射。' }],
      faq: [{ q: '效果永久吗？', a: '是的，破坏后的脂肪细胞不可再生。' }],
      meta: { title: 'Richmond Hill 身体局部溶脂针 | 消除副乳拜拜肉 | Halo Clinic医美', description: 'Richmond Hill身体溶脂针，精准消除副乳、手臂拜拜肉及局部顽固脂肪。' }
    }
  },
  {
    slug: 'ulthera-prime-body',
    id: '11b',
    category: 'body',
    image: ultherapybody,
    en: {
      title: 'Ulthera® Prime Body Ultrasound Lifting',
      subtitle: 'Targeted micro-focused ultrasound lifting for body skin laxity.',
      description: 'FDA-cleared ultrasound lifting for abdominal laxity, above knees, and upper arms.',
      purpose: 'Lifts sagging body skin and firms dermal foundation.',
      mechanism: 'Deep micro-focused ultrasound triggers neocollagenesis at 4.5mm and 6.0mm depths.',
      duration: '60 mins per area. Lasts 12-24 months.',
      features: ['FDA-cleared body skin lifting', 'Real-time ultrasound visualization', 'Tightens loose post-pregnancy skin'],
      indications: ['Post-pregnancy loose abdominal skin', 'Crepey skin above knees & arms'],
      process: [{ title: 'Body Ultrasound Scan & Treatment', desc: 'Scanning and thermal energy placement.' }],
      faq: [{ q: 'Can Ultherapy tighten loose stomach skin?', a: 'Yes, it is highly effective for post-baby belly laxity.' }],
      meta: { title: 'Ultherapy Body Skin Lifting Richmond Hill | Halo Clinic', description: 'Firm loose body skin with Ulthera Prime Body in Richmond Hill.' }
    },
    cn: {
      title: '美版超声刀 Body 身体紧致（Ulthera Prime Body）',
      subtitle: '聚焦超声波提拉腹部、手臂及膝盖上方松弛皮肤。',
      description: '唯一获得FDA认证的超声拉皮技术，用于身体局部皮肤松弛提升。',
      purpose: '紧致产后松弛腹部、收紧手臂及膝盖松弛纹理。',
      mechanism: '聚焦超声波深入身体深层皮下与筋膜层刺激胶原蛋白自生。',
      duration: '单次约60分钟，效果维持1-2年。',
      features: ['FDA认证身体皮肤提拉', '实时超声监视定位', '产后腹部松弛救星'],
      indications: ['产后腹部皮肤松弛干瘪', '膝盖上方松弛纹'],
      process: [{ title: '定位扫打', desc: '实时扫描超声打格。' }],
      faq: [{ q: '能做产后肚子松弛吗？', a: '非常适合，是收紧产后腹部松弛干瘪的顶级选择。' }],
      meta: { title: 'Richmond Hill 美版超声刀身体紧致 | 产后腹部收紧 | Halo Clinic医美', description: 'Richmond Hill美版超声刀身体紧致，收紧产后腹部松弛与身体皮肤下垂。' }
    }
  }
];

export const getServiceBySlug = (slug) => {
  return servicesData.find((s) => s.slug === slug);
};

export const getServicesByCategory = (category, lang = 'en') => {
  if (category === 'all') {
    return servicesData.map((s) => ({ ...s[lang], slug: s.slug, id: s.id, category: s.category, image: s.image }));
  }
  return servicesData
    .filter((s) => s.category === category)
    .map((s) => ({ ...s[lang], slug: s.slug, id: s.id, category: s.category, image: s.image }));
};
